module.exports = __webpack_public_path__ + "img/articlePrado.f99151e2.png";